import {FeedbackCategoryTypes} from '../../services/rest/api-types/CreateFeedbackRequestDto';
import {FeedbackSteps} from './feedback-popup.service';

export class NewFeedbackData {
    public feedbackText?: string;
    public feedbackCategory?: FeedbackCategoryTypes;

    constructor(public currentStep: FeedbackSteps,
                public learningPackageTranslationId: string,
                public quizTranslationId?: string) {
    }
}
